module.exports = __webpack_public_path__ + "static/GalanoGrotesque-Regular-443e1352796a0b8ee93d8ab17a7715af.eot";